import { DEFAULT_REGION } from "~/lib/constants/generalConstants";
import { getMetaOgTags } from "./metaOgTags";
import { DomainNameWithSubPathForLocale, GetDomainName } from "~/helpers/UrlHelper";
import { getFormattedCountryName } from "~/lib/helpers/constants";
import { useRegionConfig } from "~/store/regionConfigStore";
import { generateOrganizationLdJson } from "~/lib/helpers/schemaHelper";



export const CostatsMeta = ({
    data,
    path
}: {
    data: { areaCards?: { data: any[] }, regionData?: any },
    path: string
}) => {
    const { regionConfig } = useRegionConfig();
    const baseUrl = DomainNameWithSubPathForLocale(regionConfig?.region);
    const canonicalUrl = GetDomainName();

    const Url =
        canonicalUrl.endsWith("/") && path === "/"
            ? canonicalUrl.slice(0, -1)
            : canonicalUrl + (path === "/" ? "" : path);

    const title = `Coworking and serviced office industry market data for ${getFormattedCountryName(
        regionConfig?.region || DEFAULT_REGION
    )}`;

    const description = `View up to date market data and analytics for the coworking and serviced office industry in ${getFormattedCountryName(
        regionConfig?.region || DEFAULT_REGION
    )}. View average prices, demand, and recent rental data.`;



    const canonicalLink = [
        { tagName: "link", rel: "canonical", href: Url }
    ];


    return [
        ...getMetaOgTags({ title, description, canonicalUrl: Url }),
        ...canonicalLink,
        ...generateOrganizationLdJson(baseUrl, description, undefined, regionConfig),
    ];
};
